import React, { useState } from "react";
import styles from "./favorate-button.module.css";
import { useDispatch, useSelector } from "react-redux";
import { toFavoriteList, toNormalList } from "../../../store/reducers/list/arcanaList";

export default function FavorateButton({ isFavorite, setIsFavorite }) {
    return (
        <button
            className={`${styles["favorate-button"]} ${isFavorite ? `${styles["active"]}` : ""}`}
            title="즐겨찾기 모아보기"
            onClick={() => setIsFavorite(!isFavorite)}
        >
            ★
        </button>
    );
}
